import './reply_filter_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.PostReplyFilterView extends Monitoring.Views.SocialContents.Filters.ReplyFilterView

  render: ->
    @$el.html(@template(source: @source)) if (@searchQuery.get('post_source').length == 0) or (@type in @searchQuery.get('post_source'))
    @

  apply: =>
    @searchQuery.setPostIncludeReplies(@$el.find("##{@source}_reply_include").get(0).checked, @source)
    @searchQuery.setPostExcludeReplies(@$el.find("##{@source}_reply_exclude").get(0).checked, @source)
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
